// One-card-at-a-time carousel for the LLM search page's best-practice tips.
// The track is a native scroll-snap container, so swiping and keyboard
// scrolling work without this script; it adds the arrow buttons and dots.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-carousel]").forEach(function (carousel) {
    const track = carousel.querySelector("[data-carousel-track]");
    const prev = carousel.querySelector("[data-carousel-prev]");
    const next = carousel.querySelector("[data-carousel-next]");
    const dotsWrap = carousel.querySelector("[data-carousel-dots]");
    const slides = track ? Array.from(track.children) : [];

    if (!track || !prev || !next || slides.length < 2) {
      return;
    }

    function currentIndex() {
      const x = track.scrollLeft;
      let best = 0;
      slides.forEach(function (slide, i) {
        if (
          Math.abs(slide.offsetLeft - x) < Math.abs(slides[best].offsetLeft - x)
        ) {
          best = i;
        }
      });
      return best;
    }

    function goTo(index) {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[clamped].offsetLeft });
    }

    const dots = slides.map(function (_, i) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "llm-search-carousel__dot";
      dot.setAttribute(
        "aria-label",
        "Go to tip " + (i + 1) + " of " + slides.length
      );
      dot.addEventListener("click", function () {
        goTo(i);
      });
      if (dotsWrap) {
        dotsWrap.appendChild(dot);
      }
      return dot;
    });

    function update() {
      const index = currentIndex();
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      dots.forEach(function (dot, i) {
        dot.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    let frame = null;
    track.addEventListener("scroll", function () {
      if (frame) {
        return;
      }
      frame = window.requestAnimationFrame(function () {
        frame = null;
        update();
      });
    });
    window.addEventListener("resize", update);
    prev.addEventListener("click", function () {
      goTo(currentIndex() - 1);
    });
    next.addEventListener("click", function () {
      goTo(currentIndex() + 1);
    });
    update();
  });
});
